import * as React from "react";
import { Box } from "@mui/material";
import { MtUsageForClientBillingReportTable } from "./MtUsageForClientBillingReportTable/MtUsageForClientBillingReportTable";
import { Filter } from "./Filter/Filter";
import { useQuery } from "react-query";
import { ApiError, ClientMtUsageReport, MetricsService, MtBillingType } from "../../../gen/clients";
import { ExportAnalyticsButton } from "./ExportAnalyticsButton/ExportAnalyticsButton";

const MtUsageForClientBillingAnalyticsTab: React.FC = () => {
  const now = new Date();
  const [from, setFrom] = React.useState<Date>(new Date(now.getTime() - 30 * 24 * 60 * 60 * 1000));
  const [to, setTo] = React.useState<Date>(now);
  const [billingType, setBillingType] = React.useState<MtBillingType | "">("");
  const [searchRequestCount, setSearchRequestCount] = React.useState(0);
  const [pageToken, setPageToken] = React.useState<string | undefined>(undefined);
  const [nextPageToken, setNextPageToken] = React.useState<string | undefined>(undefined);
  const [rowsPerPage, setRowsPerPage] = React.useState<number>(10);
  const paginatorResetRef = React.useRef<() => void>(() => {});

  const { data, isFetching, error } = useQuery<ClientMtUsageReport, ApiError>(
    ["getClientMtUsageReport", from, to, billingType, searchRequestCount, pageToken, rowsPerPage],
    {
      queryFn: () =>
        MetricsService.getClientMtUsageReport({
          fromDate: from.toISOString(),
          toDate: to.toISOString(),
          pageToken,
          pageSize: rowsPerPage,
          billingType: billingType || undefined
        }),
      cacheTime: 0,
      onSuccess: collection => {
        setNextPageToken(collection.nextPageToken);
      }
    }
  );

  const onFilterChange = React.useCallback((newFrom: Date, newTo: Date, newBillingType: MtBillingType | "") => {
    setFrom(newFrom);
    setTo(newTo);
    setBillingType(newBillingType);
    setSearchRequestCount(current => current + 1);
    setPageToken(undefined);
    setNextPageToken(undefined);
    paginatorResetRef?.current();
  }, []);

  const onRowsPerPageChange = React.useCallback((newRowsPerPage: number) => {
    setRowsPerPage(newRowsPerPage);
    setPageToken(undefined);
    setNextPageToken(undefined);
    paginatorResetRef?.current();
  }, []);

  return (
    <>
      <Filter from={from} to={to} billingType={billingType} onChange={onFilterChange} />

      {from && to && (
        <Box>
          <Box textAlign="right">
            <ExportAnalyticsButton from={from} to={to} billingType={billingType || undefined} />
          </Box>
          <MtUsageForClientBillingReportTable
            data={data}
            isLoading={isFetching}
            error={error}
            rowsPerPage={rowsPerPage}
            onRowsPerPageChange={onRowsPerPageChange}
            onPageTokenChange={setPageToken}
            nextPageToken={nextPageToken}
            paginatorResetRef={paginatorResetRef}
          />
        </Box>
      )}
    </>
  );
};

export { MtUsageForClientBillingAnalyticsTab };
